import { gql } from '@apollo/client'

export const GET_AUTHENTICATED_USER = gql`
  query GetAuthenticatedUser {
    currentUser {
      ... on User {
        id
        uuid
        fullname
        isVerified
        isSuperuser
        oauthProfilePictureUrl
        columnConfigurations {
          displayName
          id
          order
          type
        }
        email
        role
        viewType
        phoneNumber
        hasSecureFilters
        settings {
          updatedAt
          favoriteCostCenters {
            id
            name
            code
            radiusVersion
          }
          homePage
        }
        customer {
          name
          type
          docInfoLabel
          enabledExceptionTypes
          enabledFilters
          surfaceConfigurations {
            order
            surface
          }
        }
        loadUserFilterGroups {
          isActive
          filterGroup {
            id
            name
          }
        }
        shipmentUserFilterGroups {
          isActive
          filterGroup {
            id
            name
          }
        }
        savedViews {
          id
          name
          surface
          isAdmin
          isActive
          filters {
            type
            value
            secondaryValue
          }
        }
      }
    }
  }
`
export const LOGOUT = gql`
  mutation LogoutAuthenticatedUser {
    logout {
      id
      role
    }
  }
`
